import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IMerchant } from '@/shared/model/merchant.model';

const baseApiUrl = 'api/merchants';
const baseSearchApiUrl = 'api/_search/merchants?query=';
const countriesApiUrl = 'api/public/settings/countries';

export default class MerchantService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IMerchant> {
    return new Promise<IMerchant>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMerchant): Promise<IMerchant> {
    return new Promise<IMerchant>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMerchant): Promise<IMerchant> {
    return new Promise<IMerchant>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  /**
   * Retrieve countries
   */
  public retrieveCountries(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(countriesApiUrl).then(function(res) {
        resolve(res);
      });
    });
  }
}
